import { createContext, useContext } from "react";

export interface IManufacturerContext {
  applicationId: string;
}

const ManufacturerContext = createContext<IManufacturerContext>({ applicationId: "" });

ManufacturerContext.displayName = "ManufacturerContext";

export const useManufacturer = () => {
  const context = useContext(ManufacturerContext);

  if (!context.applicationId) {
    throw new Error(
      "`useManufacturer` was called without an `applicationId`. This is likely because the component is not wrapped in a `ManufacturerProvider` or the provider has an invalid value."
    );
  }

  return context;
};

export default ManufacturerContext;
